import * as R from "ramda";
import { Component, Vue, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import "./header.less";

@Component
export default class Header extends Vue {
  @Prop({ default: () => {} }) readonly config: any;

  render(h) {
    return (
      <div class="header">
        {this.renderLeft(h)}
        {this.renderRight(h)}
      </div>
    );
  }

  renderLeft(h) {
    const { left } = this.config;

    return (
      <div class="header-left">{left ? this.renderButtons(h, left) : null}</div>
    );
  }

  renderRight(h) {
    const { right } = this.config;
    if (!right) return null;
    const { search } = right;
    return (
      <div>
        {R.ifElse(
          R.isEmpty,
          R.always(null),
          R.curry(this.renderSearch)(h)
        )(search)}
      </div>
    );
  }

  renderSearch(h: CreateElement, options) {
    return h("a-input-search", options);
  }

  renderButtons(h: CreateElement, data) {
    const getButtonsOption = R.prop("buttons");

    const renderButton = ({ value, ...rest }) => {
      return h("a-button", rest, value);
    };

    const mapButtons = R.map(renderButton);

    const render = R.pipe(getButtonsOption, mapButtons);

    return render(data);
  }
}
